import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, FormGroup, Modal, Button, FormControl, ControlLabel, Checkbox, Tooltip, OverlayTrigger  } from "react-bootstrap";
import Select from "react-select";
import LoaderInline from "../helpers/LoaderInline";
import InlineError from "../messages/InlineError";
import { getMinutes } from "../helpers/HelperFunctions";

class LogHoursModal extends Component {

	submit = (e) => {
		e.preventDefault();
		this.props.onSubmit();
	}
	
	render() {
		const minutes = getMinutes(60);
		const tooltip = <Tooltip placement="bottom" className="in modal-tooltip" id="tooltip-bottom">Log hours directly to project</Tooltip>;
	  	return (
			  <React.Fragment>	
				<Modal bsSize="lg" className="log-hours-modal" show={this.props.showLogModal}>
					<form onSubmit={this.submit}>	
						<Modal.Header>
							<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={this.props.handleLogHoursModal}>&times;</button>
							<Modal.Title>Log Hours</Modal.Title>
						</Modal.Header>
						<Modal.Body>						
							<Row>
								{this.props.tasks && Array.isArray(this.props.tasks) &&  this.props.tasks.length === 0 ? 
									<Col md={12}><span className="alert alert-warning modal-warning pull-left">You do not have any assigned tasks!</span></Col>
								  	: null
								}
								{this.props.errors.logged_at && <Col md={12}><span className="alert alert-danger modal-warning pull-left">You can not log hours for incoming days!</span></Col>}

								<Col md={8} sm={8} xs={8}>
									<FormGroup validationState={this.props.errors.task_id && "error"}>
										<ControlLabel>Choose Task:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onSelectChange(option, "task_id", "selectedTask"); }}
											name="task_id"
											placeholder="Choose Task"
											value={this.props.selectedTask}
											options={this.props.tasks}
											clearable={false}
											multi={false}
											disabled={this.props.directTask}
										/>	
										{this.props.errors.task_id && <InlineError text={this.props.errors.task_id}/> }		 
									</FormGroup> 
								</Col>
								{this.props.isForcedToLog ? null : 
									<Col md={4} sm={4} xs={4}>
										<OverlayTrigger placement="bottom" overlay={tooltip}>
											<FormGroup className="modal-checkbox">
												<Checkbox name="directTask" inline onChange={this.props.onCheckboxChange} checked={this.props.directTask}>
												Direct Task
												</Checkbox> 
    									</FormGroup>
										</OverlayTrigger>
									</Col>
								}
							</Row>
							<Row>
								<Col md={4} sm={4} xs={6}>
									<FormGroup validationState={this.props.errors.time && "error"}>
										<ControlLabel>Hours:</ControlLabel>
										<FormControl type="string" name="time" placeholder="Enter hours" value={this.props.hours || ""} onChange={this.props.onChangeHours}/>														                                
										{this.props.errors.time && <InlineError text={this.props.errors.time}/>}		 											
									</FormGroup>
								</Col>
								<Col md={4} sm={4} xs={6}>
									<FormGroup validationState={this.props.errors.time && "error"}>
										<ControlLabel>Minutes:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onMinutesSelectChange(option); }}
											name="minutes"
											placeholder="Enter Minutes"
											value={this.props.minutes}
											options={minutes}
											clearable
											multi={false}
										/>															                                
									</FormGroup>
								</Col>
								<Col md={4} sm={4} xs={12}>
									<FormGroup validationState={this.props.errors.log_type_id && "error"}>
										<ControlLabel>Log type:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onSelectChange(option, "log_type_id", "selectedLogType"); }}
											name="log_type_id"
											placeholder="Choose log type"
											value={this.props.selectedLogType}
											options={this.props.logTypes}
											clearable={false}
											multi={false}
										/>		
										{this.props.errors.log_type_id && <InlineError text={this.props.errors.log_type_id} />}															                                
									</FormGroup>
								</Col>							
							</Row>
														
							{/* direct task log hours inputs */}
							{this.props.directTask && 
							<Row>					
								<Col md={4} sm={4} xs={12}>
									<FormGroup validationState={this.props.errors.project_id && "error"}>
										<ControlLabel>Project:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onProjectsSelectChange(option, "project_id", "selectedProject"); }}
											name="project_id"
											placeholder="Choose parent project"
											value={this.props.selectedProject}
											options={this.props.projects}
											isLoading={this.props.isLoadingProjects}
											clearable
											multi={false}
										/>
										{this.props.errors.project_id && <InlineError text={this.props.errors.project_id} />}														                                
									</FormGroup>
								</Col>
								<Col md={4} sm={4} xs={12}>
									<FormGroup validationState={this.props.errors.area_id && "error"}>
										<ControlLabel>Area:</ControlLabel>
										<Select
											onChange={(option) => { this.props.onSelectChange(option, "area_id", "selectedArea"); }}
											name="area_id"
											placeholder="Choose project area"
											value={this.props.selectedArea}
											options={this.props.areas}
											isLoading={this.props.isLoadingAreas}
											clearable
											multi={false}
										/>		
										{this.props.errors.area_id && <InlineError text={this.props.errors.area_id}/> }
									</FormGroup>
								</Col>	
								<Col md={4} sm={4} xs={12}>
									<FormGroup validationState={this.props.errors.name && "error"}>
										<ControlLabel>Task name:</ControlLabel>
										<FormControl type="string" name="name" placeholder="Enter task name" value={this.props.formData.name || ""} onChange={this.props.onChange}/>														                                		 											
										{this.props.errors.name && <InlineError text={this.props.errors.name}/> }
									</FormGroup>
								</Col>	
							</Row>		
							}										
							{/* end of new task inputs  */}					
							<Row>
								<Col md={12}>
									<FormGroup validationState={this.props.errors.description && "error"}>
										<ControlLabel>Description</ControlLabel>                                  
										<FormControl componentClass="textarea" name="description" value={this.props.formData.description || ""} onChange={this.props.onChange}/>																				                                							
										{this.props.errors.description && <InlineError text={this.props.errors.description}/> }
									</FormGroup>
								</Col>
							</Row>
						</Modal.Body>
		
						<Modal.Footer>
							<Button bsStyle="primary" className="btn-min" type={"submit"} disabled={this.props.isLoggingHours}>
								{this.props.isLoggingHours ? <LoaderInline width="20" height="20" color="#fff" /> : "Log Hours"}
							</Button>
							<Button bsStyle="default" className="btn-min" onClick={this.props.handleLogHoursModal}>Close</Button>
						</Modal.Footer>
					</form>
				</Modal>
			</React.Fragment>
	 	 );
	}
}

LogHoursModal.defaultProps = {
	selectedTask: PropTypes.object,
	selectedLogType: PropTypes.object,
	selectedProject: PropTypes.object,
	selectedArea: PropTypes.object,
	errors: PropTypes.object,
	minutes: PropTypes.number,
	hours: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	isForcedToLog: null,
};

LogHoursModal.propTypes = {
	isForcedToLog: PropTypes.bool,
	showLogModal: PropTypes.bool.isRequired,
	directTask: PropTypes.bool.isRequired,
	isLoggingHours: PropTypes.bool.isRequired,
	isLoadingProjects: PropTypes.bool.isRequired,
	isLoadingAreas: PropTypes.bool.isRequired,
	hours: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	formData: PropTypes.shape({
		time: PropTypes.string,
		name: PropTypes.string,
		description: PropTypes.string
	}).isRequired,
	errors: PropTypes.shape({
		description: PropTypes.string,
		task_id: PropTypes.string,
		time: PropTypes.string,
		name: PropTypes.string,
		project_id: PropTypes.string,
		area_id: PropTypes.string,
		log_type_id: PropTypes.string,
		logged_at: PropTypes.string
	}),
	tasks: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	projects: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	areas: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	logTypes: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	selectedTask: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	selectedLogType: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	selectedProject: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	selectedArea: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	minutes: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	onSubmit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	onChangeHours: PropTypes.func.isRequired,
	onSelectChange: PropTypes.func.isRequired,
	onProjectsSelectChange: PropTypes.func.isRequired,
	onCheckboxChange: PropTypes.func.isRequired,
	onMinutesSelectChange: PropTypes.func.isRequired,
	handleLogHoursModal: PropTypes.func.isRequired
};

export default LogHoursModal;



// WEBPACK FOOTER //
// ./src/components/modals/LogHoursModal.js